module.exports = "/_next/static/resources/ya-wide-3e95f4cb6efcbcd6e0b83b804a4cfb12.webp";